const SEGMENT = 160
const BYTES_IN_KB = 1024
const EMOJI_SEGMENT = 70
const MAX_ATTACHMENT_KB = 500
const MMS_CHARACTER_LIMIT = 1600
const MMS_CREDIT_COUNT = 3
const PHOTO_ATTACHMENT_KB = 5000

const forbiddenWords = [
  'Cannabis',
  'Weed',
  'Pot',
  'Mary Jane',
  'Ganja',
  'Herb',
  'Dope',
  'Delta',
  'Cigar',
  'Dispensary',
  'Kratom',
  'Bud',
  'Reefer',
  'Joint',
  'Blunt',
  'Nitrous',
  'Bong',
  'Hash',
  'THC',
  'Tetrahydrocannabinol',
  'Kush',
  'Sativa',
  'Indica',
  'Hybrid',
  'Stoner',
  'Toke',
  'Smoke',
  'Dab',
  'Shatter',
  'Wax',
  'Edibles',
  'Hemp',
  '420',
  '4/20',
  'Dispensary',
  'Chronic',
  'Skunk',
  'Spliff',
  'Nugs',
  'Kratom',
  'Sinsemilla',
  'Cannabidiol',
  'CBD',
  'Cannabinoids',
  'Endocannabinoid',
  'Tincture',
  'Capsules',
  'Gummies',
  'Salves',
  'Non-psychoactive',
  'Terpenes',
  'Phytocannabinoids',
  'CBD-rich',
  'Hemp-derived',
  'Cannaflavins',
  'Cannabinoid',
  'Poker',
  'Blackjack',
  'Roulette',
  'Craps',
  'Baccarat',
  'Slots',
  'Keno',
  'Pai Gow',
  'Sic Bo',
  'Faro',
  'Klondike',
  'Canasta',
  'Pinochle',
  'Backgammon',
  'Dominoes',
  'Pachinko',
  'Hanafuda',
  'Pontoon',
  'Wager',
  'Gamble',
  'Jackpot',
  'Lottery',
  'Bookmaker',
  'Sweepstakes',
  'Stake',
  'Parlay',
  'sex',
  'nudes',
  'stripper',
  'OnlyFans',
  'naked',
  'drug',
  'drugs',
]

export {
  BYTES_IN_KB,
  EMOJI_SEGMENT,
  MAX_ATTACHMENT_KB,
  MMS_CHARACTER_LIMIT,
  MMS_CREDIT_COUNT,
  PHOTO_ATTACHMENT_KB,
  SEGMENT,
  forbiddenWords,
}
